<H3 class="text-center">Finances</H3>
<div class="card bg-light shadow-sm" [hidden]="!visibleFilters">
    <div class="card-body">
        <form name="frmTakapaFilter" #ngFrmTakapaFilter="ngForm">
            <div class="row">
                <div class="col-2 d-flex flex-wrap">
                    <div class="full-width">
                        <label class="control-label">Période de</label>
                        <div class="d-flex flex-row justify-content-between full-width">
                            <label class="control-label">Mois</label>
                            <input type="text" name="Mm_De" minlength="2" maxlength="2" class="form-control" required
                                [(ngModel)]="filters.MmDe" placeholder="MM" style="width:30px;" />
                            <label class="control-label ml-1">Annee</label>
                            <input type="text" name="Aaaa_De" minlength="4" maxlength="4" class="form-control" required
                                [(ngModel)]="filters.AaaaDe" placeholder="AAAA" style="width:40px;" />
                            <div class="flex-fill"></div>
                        </div>
                    </div>
                    <div class="flex-fill"></div>
                    <div class="full-width">
                        <label class="control-label">Période à</label>
                        <div class="d-flex flex-row justify-content-between full-width">
                            <label class="control-label">Mois</label>
                            <input type="text" name="Mm_A" minlength="2" maxlength="2" class="form-control" required
                                [(ngModel)]="filters.MmA" placeholder="MM" style="width:30px;" />
                            <label class="control-label ml-1">Annee</label>
                            <input type="text" name="Aaaa_A" minlength="4" maxlength="4" class="form-control" required
                                [(ngModel)]="filters.AaaaA" placeholder="AAAA" style="width:40px;" />
                            <div class="flex-fill"></div>
                        </div>
                    </div>
                </div>
                <div class="col-10 d-flex flex-column">
                    <div class="row">
                        <div class="col-4 d-flex flex-column">
                            <label class="control-label">Axe 1</label>
                            <kendo-multiselect class="form-control" [filterable]="true" textField="PolLib"
                                valueField="PolCod" [valuePrimitive]="true" name="Poles" [data]="filteredPoles"
                                [(ngModel)]="this.filters.PolCods" style="width:100%;" #cboPoles
                                (filterChange)="onPolesFilterChanged($event)"
                                (valueChange)="onAxeChanged($event,'PolCods')">
                                <ng-template kendoMultiSelectTagTemplate let-dataItem>
                                    {{dataItem.PolLib}}
                                </ng-template>
                                <ng-template kendoMultiSelectItemTemplate let-dataItem>
                                    <div style="width:100%;"
                                        [innerHTML]="sharedDataSvc.highlightSearch(dataItem.PolLib,poleSearchMask)">
                                    </div>
                                </ng-template>
                            </kendo-multiselect>
                        </div>
                        <div class="col-4 d-flex flex-column">
                            <label class="control-label">Axe 2</label>
                            <kendo-multiselect 
                                class="form-control" 
                                [filterable]="true" 
                                textField="RegLib"
                                valueField="RegCod" 
                                [valuePrimitive]="true" 
                                name="Regs" 
                                [data]="filteredRegs"
                                style="width:100%;" 
                                [(ngModel)]="filters.RegCods"
                                (filterChange)="onRegsFilterChanged($event)" 
                                (valueChange)="onAxeChanged($event,'RegCods')"
                                #cboRegs>
                                <ng-template kendoMultiSelectTagTemplate let-dataItem>
                                    {{dataItem.RegLib}}
                                </ng-template>
                                <ng-template kendoMultiSelectItemTemplate let-dataItem>
                                    <div style="width:100%;"
                                        [innerHTML]="sharedDataSvc.highlightSearch(dataItem.RegLib,regSearchMask)">
                                    </div>
                                </ng-template>
                            </kendo-multiselect>
                        </div>
                        <div class="col-4 d-flex flex-column">
                            <label class="control-label">Etablissement</label>
                            <kendo-multiselect 
                                class="form-control" 
                                [filterable]="true" 
                                textField="EtbLib"
                                valueField="EtbCod" 
                                [valuePrimitive]="true" 
                                name="Etbs" 
                                [data]="filteredEtbs"
                                style="width:100%;" 
                                [(ngModel)]="filters.EtbCods"
                                (filterChange)="onEtbsFilterChanged($event)" 
                                #cboEtbs>
                                <ng-template kendoMultiSelectTagTemplate let-dataItem>
                                    {{displayEtb(dataItem)}}
                                </ng-template>
                                <ng-template kendoMultiSelectItemTemplate let-dataItem>
                                    <div style="width:100%;"
                                        [innerHTML]="sharedDataSvc.highlightSearch(displayEtb(dataItem),etbSearchMask)">
                                    </div>
                                </ng-template>
                            </kendo-multiselect>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-2 d-flex flex-column">
                    <label class="control-label">Données</label>
                    <select class="form-control" [(ngModel)]="filters.FacCdeCta" name="FacCdeCta" style="width:100%;">
                        <option *ngFor="let t of lstDonnees" [value]="t.Key">{{t.Value}}</option>
                    </select>
                </div>
                <div class="col-10">
                    <div class="row">
                        <div class="col-4 d-flex flex-column">
                            <label class="control-label">Segment</label>
                            <kendo-multiselect 
                                class="form-control" 
                                name="Segments" 
                                [data]="filteredSegments"
                                style="width:100%;" 
                                [filterable]="true" 
                                [(ngModel)]="filters.Families"
                                (filterChange)="onFamilyFilterChanged($event)" 
                                (valueChange)="onFamilyChange($event,'Segments')"
                                #cboSegments>
                                <ng-template kendoMultiSelectItemTemplate let-dataItem>
                                    <div style="width:100%;"
                                        [innerHTML]="sharedDataSvc.highlightSearch(dataItem,takFamilySearchMask)"></div>
                                </ng-template>
                            </kendo-multiselect>
                        </div>
                        <div class="col-4 d-flex flex-column">
                            <label class="control-label">Famille</label>
                            <kendo-multiselect 
                                class="form-control" 
                                name="TakSubTyps" 
                                [data]="filteredSubTyps"
                                style="width:100%;" 
                                [filterable]="true" 
                                [(ngModel)]="filters.SubTyps"
                                (filterChange)="onSubTypFilterChanged($event)" 
                                (valueChange)="onFamilyChange($event,'Families')"
                                #cboTakSubtyps>
                                <ng-template kendoMultiSelectItemTemplate let-dataItem>
                                    <div style="width:100%;"
                                        [innerHTML]="sharedDataSvc.highlightSearch(dataItem,takSubTypSearchMask)"></div>
                                </ng-template>
                            </kendo-multiselect>
                        </div>
                        <div class="col-4 d-flex flex-column">
                            <label class="control-label">Sous-famille</label>
                            <kendo-multiselect 
                                class="form-control" 
                                name="TakSubTyps2" 
                                [data]="filteredSubTyp2s"
                                style="width:100%;" 
                                [filterable]="true" 
                                [(ngModel)]="filters.SubTyp2s"
                                (filterChange)="onSubTyp2FilterChanged($event)" 
                                #cboTakSubtyps2>
                                <ng-template kendoMultiSelectItemTemplate let-dataItem>
                                    <div style="width:100%;"
                                        [innerHTML]="sharedDataSvc.highlightSearch(dataItem,takSubTyp2SearchMask)">
                                    </div>
                                </ng-template>
                            </kendo-multiselect>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-2 d-flex flex-column">
                    <label class="control-label">Présentation</label>
                    <select class="form-control" [(ngModel)]="filters.Presentation" name="Presentation"
                        style="width:100%;">
                        <option *ngFor="let t of lstPresentations" [value]="t.Key">{{t.Value}}</option>
                    </select>
                </div>
                <div class="col-5 d-flex flex-column">
                    <label class="control-label">Fournisseur - Code Tiers ou Nom</label>
                    <ng-template #supplierResultTpl let-r="result" let-t="term">
                        <ngb-highlight [accentSensitive]="false" [result]="supplierResultFormatter(r)" [term]="t"></ngb-highlight>
                    </ng-template>
                    <input 
                        name="tieCod" 
                        type="text" 
                        class="form-control" 
                        style="width:100%;" 
                        [(ngModel)]="supplierInput"
                        [ngbTypeahead]="searchSuppliers" 
                        [resultTemplate]="supplierResultTpl"
                        [inputFormatter]="supplierResultFormatter"
                        (blur)="onSupplierBlur()"
                        [editable]="false"
                        #tieCod />
                    <small *ngIf="isSearchingSuppliers" class="form-text text-muted">recherche en cours...</small>
                </div>
                <div class="col-5 d-flex flex-column">
                    <label class="control-label">Groupe</label>
                    <ng-template #groupResultTpl let-r="result" let-t="term">
                        <ngb-highlight [accentSensitive]="false" [result]="r" [term]="t"></ngb-highlight>
                    </ng-template>
                    <input name="group" type="text" class="form-control" [(ngModel)]="filters.Groupe"
                        style="width:100%;" [ngbTypeahead]="searchGroups" [resultTemplate]="groupResultTpl"
                        [editable]="false" />
                    <small *ngIf="isSearchingGroups" class="form-text text-muted">recherche en cours...</small>
                </div>
            </div>
        </form>
    </div>
</div>

<div class="row mt-2">
    <div class="col text-center">
        <button class="btn btn-sm btn-primary float-left" type="button" (click)="toggleDisplayFilters()">
            <span [hidden]="visibleFilters">
                <paflabel lblCod="Filtres_de_recherche"></paflabel>&nbsp;<i class="fas fa-search"></i>
            </span>
            <span [hidden]="!visibleFilters">
                <paflabel lblCod="Masquer_les_filtres"></paflabel>&nbsp;<i class="far fa-caret-square-up"></i>
            </span>
        </button>
        <button class="btn btn-sm btn-primary mx-2" type="commit" (click)="search()"
            [disabled]="!this.filters.Presentation"><i class="fas fa-search mr-1"></i>Rechercher</button>
        <button class="btn btn-sm btn-success mx-2" type="button" (click)="exportExcel()"
            [disabled]="!this.filters.Presentation"><i class="far fa-file-excel mr-1"></i>Exporter</button>
        <button class="btn btn-sm btn-warning mx-2" type="button" (click)="reinit()"><i
                class="fas fa-ban mr-1"></i>Réinitialiser filtres</button>
        <button class="btn btn-sm btn-danger mx-2" type="button" (click)="reinitAll()"><i
                class="fas fa-ban mr-1"></i>Réinitialiser tout</button>
    </div>
</div>


<pre *ngIf="sharedDataSvc.debug">supplierInput : {{supplierInput | json}}</pre>
<pre *ngIf="sharedDataSvc.debug">Filtres : {{filters | json}}</pre>

<div class="card mt-1">
    <div class="card-body">
        <kendo-grid class="takapa-grid-results header-wrap" id="grid" #grid="kendoGrid" [data]="gridData" [pageSize]="state.take"
            [resizable]="true" [skip]="state.skip" [sort]="state.sort" [filter]="state.filter" [sortable]="true"
            [pageable]="gridPageableSettings" [filterable]="'menu'" [height]="gridHeight" [reorderable]="true"
            (filterChange)="filterChange($event)" 
            (dataStateChange)="dataStateChange($event)" 
            #financesGrid>
            <kendo-grid-messages filterIsFalse="Non&nbsp;&nbsp;" filterIsTrue="Oui&nbsp;&nbsp;">
            </kendo-grid-messages>
        
        
            <kendo-grid-column field="GrpLib" title="Groupe" [width]="250">
                <ng-template kendoGridFooterTemplate>
                    <div class="text-left">Total général de la sélection</div>
                </ng-template>
            </kendo-grid-column>
            <kendo-grid-column *ngIf="presentation!='GRP'" field="TieCod" class="text-center" title="Code tiers" [width]="100">
            </kendo-grid-column>
            <kendo-grid-column *ngIf="presentation!='GRP'" field="TieLib" title="Nom du fournisseur" [width]="250">
                <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex" let-column="column">
                    <a *ngIf="dataItem.SupplierId!=null" class="control-label" [routerLink]="getSupplierLink(dataItem)"
                        [paftooltip]="'Fiche_fournisseur'" target="_blank">
                        {{ dataItem.TieLib }}
                    </a>
                    <span *ngIf="dataItem.SupplierId == null" data-toggle="tooltip"
                        title="Fournisseur Takapa non présent dans le portail">{{dataItem.TieLib}}</span>
                </ng-template>
            </kendo-grid-column>
            <kendo-grid-column field="MtHt" class="text-right text-currency" title="Montant HT" filter="numeric" format="{0:c}"
                [width]="160">
                <ng-template kendoGridFooterTemplate>
                    <div class="text-right text-currency">{{getMontantTotal() | currency }}</div>
                </ng-template>
            </kendo-grid-column>
            <kendo-grid-column field="Nb_Factures" class="text-center text-currency" title="Nombre pièces" filter="numeric"
                [width]="160">
                <ng-template kendoGridFooterTemplate>
                    <div class="text-center text-currency"> {{getTotalFactures() | number : '1.0-0' : 'fr'}}</div>
                </ng-template>
            </kendo-grid-column>
            <kendo-grid-column *ngIf="presentation=='ETB'" field="Part_Dans_La_Dr" class="text-right text-currency"
                title="% Etb" filter="numeric" format="{0:p2}" [width]="120"></kendo-grid-column>
            <kendo-grid-column *ngIf="presentation=='ETB'" field="EtbCod" class="text-center" title="Code Etb"
                [width]="100"></kendo-grid-column>
            <kendo-grid-column *ngIf="presentation=='ETB'" field="EtbLib" title="Nom Etb" [width]="200"></kendo-grid-column>
        
            <kendo-grid-column-group title="Indicateurs" [columnMenu]="false" class="text-center" [resizable]="false">
                <kendo-grid-column field="IndLeg" title="" [width]="28" class="text-center" [filterable]="false"
                    [sortable]="false" [class]="'indicateur-header'" [resizable]="false">
                    <ng-template kendoGridHeaderTemplate>
                        <img class="grid-header-image" title="Indicateur légal" data-toggle="tooltip"
                            src="./assets/images/legal.png">
                    </ng-template>
                    <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex" let-column="column">
                        <div class="indicateur" [ngClass]="indicateurClass(dataItem.IndLeg)" data-toggle="tooltip"
                            [title]="convertTooltip(dataItem.DetailLeg)"></div>
                    </ng-template>
                </kendo-grid-column>
                <kendo-grid-column field="IndFin" title="" [width]="28" class="text-center" [filterable]="false"
                    [sortable]="false" [class]="'indicateur-header'" [resizable]="false">
                    <ng-template kendoGridHeaderTemplate>
                        <img class="grid-header-image" title="Indicateur financier" data-toggle="tooltip"
                            src="./assets/images/financier.png">
                    </ng-template>
                    <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex" let-column="column">
                        <div class="indicateur" [ngClass]="indicateurClass(dataItem.IndFin)" data-toggle="tooltip"
                            [title]="convertTooltip(dataItem.DetailFin)"></div>
                    </ng-template>
                </kendo-grid-column>
                <kendo-grid-column field="Ind3se" title="" [width]="28" class="text-center" [filterable]="false"
                    [sortable]="false" [class]="'indicateur-header'" [resizable]="false">
                    <ng-template kendoGridHeaderTemplate>
                        <img class="grid-header-image" title="Indicateur 3SE" data-toggle="tooltip"
                            src="./assets/images/3se.png">
                    </ng-template>
                    <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex" let-column="column">
                        <div class="indicateur" [ngClass]="indicateurClass(dataItem.Ind3se)" data-toggle="tooltip"
                            [title]="convertTooltip(dataItem.Detail3se)"></div>
                    </ng-template>
                </kendo-grid-column>
                <kendo-grid-column field="IndQual" title="" [width]="28" class="text-center" [filterable]="false"
                    [sortable]="false" [class]="'indicateur-header'" [resizable]="false">
                    <ng-template kendoGridHeaderTemplate>
                        <img class="grid-header-image" title="Indicateur qualité" data-toggle="tooltip"
                            src="./assets/images/qualite.png">
                    </ng-template>
                    <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex" let-column="column">
                        <div class="indicateur" [ngClass]="indicateurClass(dataItem.IndQual)" data-toggle="tooltip"
                            [title]="convertTooltip(dataItem.DetailQual)"></div>
                    </ng-template>
                </kendo-grid-column>
            </kendo-grid-column-group>
            <kendo-grid-column field="TypAch_Famille_Fourn" title="Segment" [width]="200"></kendo-grid-column>
            <kendo-grid-column field="TypAch_Sous_Type" title="Famille" [width]="200"></kendo-grid-column>
            <kendo-grid-column field="TypAch_Sous_Sous_Type" title="Sous-famille" [width]="200"></kendo-grid-column>
            <kendo-grid-column field="Acc_Code" title="Accord" [width]="200"></kendo-grid-column>
            <kendo-grid-column *ngIf="presentation=='ETB'" field="isPanelReg" title="Panel régional" [width]="120"
                filter="boolean">
                <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
                    <div style="text-align: center;"><i [ngClass]="checkNgClass(dataItem.TopPanelReg)"></i></div>
                </ng-template>
            </kendo-grid-column>
            <kendo-grid-column field="isESAT" title="ESAT" [width]="100" filter="boolean">
                <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
                    <div style="text-align: center;"><i [ngClass]="checkNgClass(dataItem.TopESAT)"></i></div>
                </ng-template>
            </kendo-grid-column>
            <kendo-grid-column [width]="80" field="isEA" title="EA" filter="boolean">
                <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
                    <div style="text-align: center;"><i [ngClass]="checkNgClass(dataItem.TopEA)"></i></div>
                </ng-template>
            </kendo-grid-column>
            <kendo-grid-column [width]="80" field="isTIH" title="TIH" filter="boolean">
                <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
                    <div style="text-align: center;"><i [ngClass]="checkNgClass(dataItem.TopTIH)"></i></div>
                </ng-template>
            </kendo-grid-column>
            <kendo-grid-column field="PAY_Cod" title="Pays" [width]="60" [filterable]="false"></kendo-grid-column>
            <kendo-grid-column [width]="100" field="ScoreValue" title="Note financière" filter="numeric">
                <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
                    <div *ngIf="dataItem.ScoreValue" style="text-align: center;" data-toggle="tooltip" [title]="convertTooltip(dataItem.ScoreDescription)">
                        {{dataItem.ScoreValue}} / {{dataItem.ScoreMax}}
                    </div>
                    <div *ngIf="!dataItem.ScoreValue" style="text-align: center;">NC</div>
                </ng-template>
            </kendo-grid-column>
            <kendo-grid-column [width]="120" field="isRayonnement" title="Sous rayonnement" filter="boolean">
                <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
                    <div style="text-align: center;"><i [ngClass]="checkNgClass(dataItem.TopRayonnement)"></i></div>
                </ng-template>
            </kendo-grid-column>
            <kendo-grid-column [width]="100" field="NoteEVF" class="text-center" title="Note moyenne des EVF" filter="numeric" format="{0:n2}">
            </kendo-grid-column>
            <kendo-grid-column [width]="150" field="Detail3se" title="Détail 3SE">
                <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
                    <div style="text-align: center;">{{convertTooltip(dataItem.Detail3se)}}</div>
                </ng-template>                
            </kendo-grid-column>
        </kendo-grid>
        
        <kendo-excelexport 
            [fileName]="excelExportFileName" 
            [filterable]="true"
            #excelexport>
            <kendo-excelexport-column field="GrpLib" title="Groupe"></kendo-excelexport-column>
            <kendo-excelexport-column  *ngIf="presentation!='GRP'" field="TieCod" title="Code tiers"></kendo-excelexport-column>
            <kendo-excelexport-column  *ngIf="presentation!='GRP'" field="TieLib" title="Nom du fournisseur"></kendo-excelexport-column>
            <kendo-excelexport-column field="MtHt" [cellOptions]="{ format: '#,##0.00 €' }" class="text-right"
                title="Montant HT" filter="numeric" format="{0:c}"></kendo-excelexport-column>
            <kendo-excelexport-column field="Nb_Factures" class="text-right" title="Nombre pièces"
                filter="numeric"></kendo-excelexport-column>
            <kendo-excelexport-column *ngIf="presentation=='ETB'" field="Part_Dans_La_Dr" class="text-right" title="% Etb"
                [cellOptions]="{ format: '#,##0.00 %' }" filter="numeric"></kendo-excelexport-column>
            <kendo-excelexport-column *ngIf="presentation=='ETB'"field="EtbCod" class="text-center" title="Code Etb"></kendo-excelexport-column>
            <kendo-excelexport-column *ngIf="presentation=='ETB'" field="EtbLib" title="Nom Etb"></kendo-excelexport-column>
            <kendo-excelexport-column field="IndLeg" title="Leg" class="text-center">
            </kendo-excelexport-column>
            <kendo-excelexport-column field="IndFin" title="Fin" class="text-center">
            </kendo-excelexport-column>
            <kendo-excelexport-column field="Ind3se" title="3SE" class="text-center">
            </kendo-excelexport-column>
            <kendo-excelexport-column field="IndQual" title="Qual" class="text-center">
            </kendo-excelexport-column>
            <kendo-excelexport-column field="TypAch_Famille_Fourn" title="Segment"></kendo-excelexport-column>
            <kendo-excelexport-column field="TypAch_Sous_Type" title="Famille"></kendo-excelexport-column>
            <kendo-excelexport-column field="TypAch_Sous_Sous_Type" title="Sous-famille"></kendo-excelexport-column>
            <kendo-excelexport-column field="Acc_Code" title="Accord"></kendo-excelexport-column>
            <kendo-excelexport-column *ngIf="presentation=='ETB'" field="isPanelReg" title="Panel régional"></kendo-excelexport-column>
            <kendo-excelexport-column field="isESAT" title="ESAT"></kendo-excelexport-column>
            <kendo-excelexport-column field="isEA" title="ESAT"></kendo-excelexport-column>
            <kendo-excelexport-column field="isTIH" title="TIH"></kendo-excelexport-column>
            <kendo-excelexport-column field="PAY_Cod" title="Pays"></kendo-excelexport-column>
            <kendo-excelexport-column field="ScoreValue" title="Note financière"></kendo-excelexport-column>
            <kendo-excelexport-column field="isRayonnement" title="Sous rayonnement"></kendo-excelexport-column>
            <kendo-excelexport-column field="NoteEVF" title="Note moyenne des EVF" class="text-right" [cellOptions]="{ format: '#,##0.00' }" filter="numeric">
            </kendo-excelexport-column>
            <kendo-excelexport-column field="Detail3seExcel" [cellOptions]="{wrap:true}" title="Détail 3SE" class="text-center">
            </kendo-excelexport-column>
        </kendo-excelexport>
        <!-- </div> -->
    </div>

</div>